import React from "react";
import ReactDOM from "react-dom/client";
import AgenciesPage from "./App"; // ← dein Componentname
// import TalentDashboard from "./components/talent-dashboard";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AgenciesPage />);